import { connect } from 'react-redux'
import { selectPosition, TradingAction } from '../actions'
import { AppMode, RootState } from '../types'
import { MT4Connector } from '@bdswiss/mt4-connector'
import SignalPositionsTable from '../components/SignalPositionsTable'
import { setAppMode, setChartMode, setTradingSignal } from '../actions/commonActions'
import { setModal } from '../actions/dialogActions'
import { I18n } from 'react-redux-i18n'
import { closeTrade } from '../actions/TradeActions'
import { Dispatch } from 'redux'
const mt4 = MT4Connector.Instance

function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onSelectPosition: (order: number, expanded?: boolean) => {
      dispatch(selectPosition(order, expanded))
    },
    onSetChartMode: () => {
      dispatch(setChartMode('open'))
    },
    onCloseTrade: (order: number, uuid?: string) => {
      dispatch(
        setModal(I18n.t(`closingPosition`), I18n.t('closePositionMessage'), closeTrade(order, uuid))
      )
    },
    onSetAppMode: (mode: AppMode) => {
      dispatch(setAppMode(mode))
    },
    onSetSignal: (signal: any) => {
      dispatch(setTradingSignal(signal))
    },
  }
}

function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    accountLoaded: state.accountLoaded,
    signals: mt4.tradeableSignals, //rootState.signals,
    assets: mt4.assets,
    positions: Array.from(mt4.positions.values()),
    currency: state.currency,
    locale: rootState.i18n.locale,
  }
}

export const SignalPositionsTableContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignalPositionsTable)
